import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "left-side" }
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = { class: "auth-links" }
const _hoisted_5 = { class: "register-link" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "email" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { for: "password" }
const _hoisted_10 = { class: "password-input-container" }
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "forgot-password-link" }
const _hoisted_13 = {
  key: 0,
  class: "error-message"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "button-content" }
const _hoisted_16 = {
  key: 0,
  class: "bi bi-arrow-right-short arrow-icon"
}

import { ref, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useProjectSummaryStore } from "@/stores/project";
import { useI18n } from "vue-i18n"; // Assuming you're using vue-i18n


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();
const projectSummaryStore = useProjectSummaryStore();
const showModal = ref(false);

const form = reactive({
  email: "",
  password: "",
});

const loading = ref(false);
const error = ref("");
const detailedError = ref("");
const showPassword = ref(false);

const handleLogin = async () => {
  try {
    loading.value = true;
    error.value = "";
    detailedError.value = "";
    console.log("Attempting login with:", { email: form.email });

    // Login user
    await authStore.login({ email: form.email, password: form.password });

    router.push("/projects");
  } catch (err: any) {
    console.error("Login error:", err);
    // Show user-friendly error message
    if (err.response?.status === 401) {
      error.value = t("auth.loginPage.errors.invalidCredentials");
    } else if (err.response?.status === 400) {
      error.value = t("auth.loginPage.errors.badRequest");
    } else if (err.request) {
      error.value = t("auth.loginPage.errors.connectionError");
    } else {
      error.value = t("auth.loginPage.errors.unexpectedError");
    }
  } finally {
    loading.value = false;
  }
};

const enterAsGuest = () => {
  showModal.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("auth.loginPage.title")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t("auth.loginPage.noAccount")) + " ", 1),
            _createVNode(_component_router_link, { to: "/register" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("auth.loginPage.register")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleLogin, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("auth.loginPage.emailLabel")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "email",
              id: "email",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
              required: "",
              class: "form-control"
            }, null, 512), [
              [_vModelText, form.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("auth.loginPage.passwordLabel")), 1),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: showPassword.value ? 'text' : 'password',
                id: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
                required: "",
                class: "form-control"
              }, null, 8, _hoisted_11), [
                [_vModelDynamic, form.password]
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "password-toggle",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(showPassword.value ? 'fas fa-eye' : 'fas fa-eye-slash')
                }, null, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_router_link, { to: "/forgot-password" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("auth.loginPage.forgotPasswordLink")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "submit",
            disabled: loading.value,
            class: "btn-primary"
          }, [
            _createElementVNode("span", _hoisted_15, [
              _createTextVNode(_toDisplayString(loading.value
                  ? _ctx.$t("auth.loginPage.loading")
                  : _ctx.$t("auth.loginPage.loginButton")) + " ", 1),
              (!loading.value)
                ? (_openBlock(), _createElementBlock("i", _hoisted_16))
                : _createCommentVNode("", true)
            ])
          ], 8, _hoisted_14)
        ], 32)
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "copyright" }, " © 2025 AZIMUT GREEN SOLUTIONS SRL — ALL RIGHTS RESERVED — Via Fratelli Ugoni, 36 25126, Brescia — P.IVA 10200640968 — REA: BS - 608085 — CAP. SOC. EUR 50.000,00 ", -1))
    ]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "right-side" }, null, -1)),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (showModal.value = false))
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.$t("auth.loginPage.guestModalTitle")), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("auth.loginPage.guestModalMessage")), 1),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showModal.value = false)),
              class: "btn-primary"
            }, _toDisplayString(_ctx.$t("auth.loginPage.closeButton")), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})